import CategoryListPanel from './categoryListPanel.container';

export default CategoryListPanel;